import { HostBinding, HostListener, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {

    currentLayOut = {
        isCondensed: true
    };

    private darkStyles = ['css_app_darkBS', 'css_app_darkTheme'];
    private lightStyles = ['css_app_lightBS', 'css_app_lightTheme', 'css_app_custom_theme'];

    constructor() { }

    setAuthLayout() {
        document.body.classList.add(...['auth-fluid-pages', 'pb-0']);
    }

    setPageLayout(appName) {
        document.body.classList.remove(...['auth-fluid-pages', 'pb-0']);
    }

    setLoading() {
        document.body.classList.add('loading');
    }

    setIdle() {
        document.body.classList.remove('loading');
    }
     
   
        
    toggleSidebar() {
        const isCondensed = this.getIsCondensed();
        //document.body.setAttribute('data-sidebar-size', this.currentLayOut.isCondensed ? 'condensed' : 'default');
        if (!this.isMobileMode()) {
            document.body.setAttribute('data-sidebar-size', isCondensed ? 'default' : 'condensed');
        } else {
            const sideBarEnabled = document.body.classList.contains('sidebar-enable');
            if (sideBarEnabled) {
                document.body.classList.remove('sidebar-enable');
            } else {
                document.body.classList.add('sidebar-enable');
            }
        }
    }

    getIsCondensed() {
        const isCondensed = document.body.getAttribute('data-sidebar-size') === 'condensed';
        return isCondensed;
    }

    initLayout() {
        document.body.setAttribute('data-layout-width', '');
    }

    switchTheme() {
        const getCurrentTheme = this.getCurrentThemeMode();
        const stylesToEnable = getCurrentTheme === 'dark' ? this.lightStyles : this.darkStyles;
        const stylesToDisable = getCurrentTheme === 'dark' ? this.darkStyles : this.lightStyles;
        stylesToEnable.forEach((style) => {
            const stylesToEnable = document.getElementById(style)
            stylesToEnable.removeAttribute('disabled');
        });
        setTimeout(() => {
            stylesToDisable.forEach((style) => {
                const styleToDisable = document.getElementById(style)
                styleToDisable.setAttribute('disabled', 'true');
            });
        }, 500);
    }

    getCurrentThemeMode() {
        const isDarkStyleDisabled = document.getElementById(this.darkStyles[0]).getAttribute('disabled');
        return isDarkStyleDisabled ? 'light' : 'dark';
    }

    isMobileMode() {
        return window.innerWidth < 993;
    }

}
